// @flow

import React from 'react'
import { roomName } from 'frontend_core/dist/helpers/format'
import { isMobile } from 'common/screen'
import CoverPhotoMobile from 'components/organisms/room/CoverPhotoMobile'
import RoomPagePresenter from 'containers/pages/RoomPage/RoomPagePresenter'
import type { Room } from 'types/room'

type PropTypes = {
  data: {
    room: Room,
  },
}

export default class CoverPhotoSlideShowContainer extends React.Component<*> {
  props: PropTypes
  roomPresenter: RoomPagePresenter

  constructor(props: PropTypes) {
    super(props)
    this.roomPresenter = new RoomPagePresenter(props.data.room)
  }

  render() {
    if (!isMobile()) {
      return null
    }

    const { room } = this.props.data
    const roomThumbnails = this.roomPresenter.getThumbnails()

    return <CoverPhotoMobile thumbnails={roomThumbnails} />
  }
}



// WEBPACK FOOTER //
// ./src/containers/organisms/room/CoverPhotoMobile/index.jsx